import { render } from "./transfer-request-edit.vue?vue&type=template&id=aad612d6&scoped=true"
import script from "./transfer-request-edit.vue?vue&type=script&lang=js"
export * from "./transfer-request-edit.vue?vue&type=script&lang=js"

import "./transfer-request-edit.vue?vue&type=style&index=0&id=aad612d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aad612d6"]])

export default __exports__